import { CustomStringParam, FilterType, SchemaFilterType } from '@ui/src';

export const columnsItems = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'externalId',
    label: 'External ID',
    hidden: false,
    sortable: false,
  },
  {
    name: 'pspPartnerId',
    label: 'Bank',
    hidden: false,
    sortable: false,
  },
  {
    name: 'organizationId',
    label: 'Customer name',
    hidden: false,
    sortable: false,
  },
  {
    name: 'organizationType',
    label: 'Type',
    hidden: false,
    sortable: false,
  },
  {
    name: 'createdAt',
    label: 'Created',
    hidden: false,
    sortable: false,
  },
  {
    name: 'active',
    label: 'Status',
    hidden: false,
    sortable: false,
  },
];

export const columnsLabels = {
  externalId: 'External ID',
  organizationType: 'Type',
  pspPartnerId: 'Bank',
};

export const schema = {
  externalId: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  organizationType: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  organizationId: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  pspPartnerId: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
};

export const filtersSchema = [
  {
    name: 'externalId',
    type: FilterType.TEXT,
    placeholder: 'Enter ID...',
  },
  {
    name: 'organizationType',
    type: FilterType.CHECKBOX,
    fields: [
      {
        name: 'organizationType',
        title: 'Individual',
        value: 'INDIVIDUAL',
      },
      {
        name: 'organizationType',
        title: 'Corporate',
        value: 'CORPORATE',
      },
    ],
  },
  {
    name: 'pspPartnerId',
    type: FilterType.AUTOCOMPLETE,
    placeholder: 'Select bank',
  },
];
